import React, { Component } from 'react'

class GeetestCaptcha extends Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }

  componentDidMount() {
    this.initGeetest4SDK()
    this.timer = setInterval(() =>{
      if(window.initGeetest4){
        this.initVerityCode();
        clearInterval(this.timer)
      }
    },100)
  }

  componentWillUnmount(){
    clearInterval(this.timer)
  }

  initVerityCode(){
    if(window.initGeetest4){
    	window.initGeetest4(this.props.captchaConfig.config,this.props.captchaConfig.handler);
    }  
  }

  initGeetest4SDK() {
    (function () {
      try {
        let s = document.createElement("script");
        let x = document.getElementsByTagName("script")[0];
        s.type = "text/javascript";
        s.async = s.defer = true;
        s.id = 'Geetest4-SDK';
        s.src = "https://www.dhresource.com/20220712/gt4.js";
        x.parentNode.insertBefore(s, x);
      } catch (e) { }
    })();

  }

  render() {
    return (
      <div className="captcha"></div>);
  }
}
export default GeetestCaptcha